export default __webpack_public_path__ + "static/media/KOD0038-min.da3777a6.webp";